module.exports = __webpack_public_path__ + "img/chinapay150x48.1499649f.gif";